import { memo, ComponentProps } from 'react'
import { Link as RouterLink } from 'react-router-dom'

export interface LinkProps extends ComponentProps<typeof RouterLink> {}

function Link(props: LinkProps) {
  return <RouterLink {...props} />
}

export default memo(Link)
